const KURZ_GROUP = new Set(["Kurz", "TF zboží", "TF cig"]);

const fuelClass = (value) =>
  `fuel-${String(value).toLowerCase().replace(/\s+/g, "-")}`;

export default function PriceTableHeader({ show, columns, eurFuels }) {
  if (!show) return null;

  const safeColumns = Array.isArray(columns) ? columns : [];
  const eurFuelsSet = eurFuels instanceof Set ? eurFuels : new Set();

  const getHeaderSlotCount = (col) => {
    const fuels = Array.isArray(col.fuels) ? col.fuels : [];

    if (col.key === "Kurz" || fuels.some((fuel) => KURZ_GROUP.has(fuel))) {
      return Math.max(fuels.filter((fuel) => KURZ_GROUP.has(fuel)).length, 1);
    }

    return fuels.some((fuel) => eurFuelsSet.has(fuel)) ? 2 : 1;
  };

  return (
    <div className="price-table-header-modern">
      <div className="price-table-header-modern__station">Produkt</div>

      <div className="price-table-header-modern__products">
        {safeColumns.map((col) => (
          <div
            key={col.key}
            className={`price-table-header-modern__cell ${fuelClass(col.key)}`}
            style={{ "--product-slots": getHeaderSlotCount(col) }}
          >
            {col.label}
          </div>
        ))}
      </div>
    </div>
  );
}